import React, { useState, useRef, useEffect } from 'react';
import "../Styles/CreateUser.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast, ToastContainer, toast as toastHelper } from 'react-toastify';
import Img from "../Assets/icons/VELOXLogo.png";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const TestYubiKey = () => {
    const navigate = useNavigate();
    const [openYubikeyDialog, setOpenYubikeyDialog] = useState(false);
    const [yubikeyCode, setYubikeyCode] = useState('');
    const yubikeyInputRef = useRef(null);
    const dialogContentRef = useRef(null);
    const location = useLocation();

    const handleBack = () => {
        console.log("Back button clicked!");
        console.log("Current path:", location.pathname);

        // Dismiss any active toasts before navigating
        toastHelper.dismiss();

        // Check if we can go back in history
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);  // Go back one step in history
            console.log("Navigating back one step.");
        } else {
            // If no history, navigate to the dashboard without adding an entry
            navigate('/dashboard', { replace: true });
            console.log("No history to go back, redirecting to dashboard.");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('@user');
        localStorage.removeItem('userEmail');
        toastHelper.dismiss();  // Ensure any active toasts are dismissed before logout
        navigate('/', { replace: true });  // Use replace to avoid adding history
    };

    const handleYubikeyVerification = () => {
        const email = localStorage.getItem('userEmail');
        Axios.post(`${process.env.REACT_APP_BACKEND_URL}/login_verify_yubikey`, {
            email: email,
            yubikeyContent: yubikeyCode,
        }).then((response) => {
            if (response.data.success) {
                localStorage.setItem('loginSuccessMessage', response.data.msg);
                setOpenYubikeyDialog(false);
                localStorage.setItem('@user', "true");
                console.log(localStorage.getItem('@user'));
                console.log("Login success, will go to dashboard");
                navigate('/dashboard');
            } else {
                toast.error(`${response.data.msg}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                if (yubikeyInputRef.current) {
                    yubikeyInputRef.current.focus();  // Set focus back to the input field if there's an error
                }
            }
            setYubikeyCode('');
        }).catch((error) => {
            console.error('Verification error:', error);
            setYubikeyCode('');
            if (yubikeyInputRef.current) {
                yubikeyInputRef.current.focus();  // Set focus back to the input field even if there's an error
            }
        });
    };

    return (
        <div>
            <div className='logo-VELOX'>
                <img src={Img} alt="VELOX Life Safety Inc." className="logo" />
                <button className='back-botton' onClick={handleBack}>BACK</button>
                <button className='signout-botton' onClick={handleLogout}>SIGN OUT</button>
            </div>
            <hr className='login-breakline' />
            <div className='register-card'>
                <h1 className='register'>Test YubiKey (Not Finished)</h1>
                <Formik
                    initialValues={{
                        firstname: '',
                        lastname: '',
                        email: '',
                        password: '',
                        yubikeyserialnumber: '',
                    }}
                    onSubmit={() => setOpenYubikeyDialog(true)}
                >
                    <Form className="register-form">
                        <div className="register-form-group">
                            <Field name="yubikeyserialnumber" type='text' className="register-form-yubikeyserialnumber-field" placeholder="YubiKey Serial Number" />
                        </div>

                        <button className="createuser-button" type="submit">
                            Verify YubiKey
                        </button>
                    </Form>
                </Formik>
            </div>

            <Dialog open={openYubikeyDialog} onClose={() => setOpenYubikeyDialog(false)}>
                <DialogTitle>YubiKey Verification</DialogTitle>
                <DialogContent ref={dialogContentRef}>
                    <p>Please insert your YubiKey, touch it, and then verify.</p>
                    <input
                        type="text"
                        ref={yubikeyInputRef}
                        className="yubikeycode-field-hidden"
                        placeholder="Enter YubiKey Code"
                        value={yubikeyCode}
                        onChange={(e) => setYubikeyCode(e.target.value)}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenYubikeyDialog(false)} color="secondary">Cancel</Button>
                    <Button onClick={handleYubikeyVerification} color="primary" disabled={!(yubikeyCode && yubikeyCode.length >= 12)}>
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer position='top-right' />
        </div>
    );
};

export default TestYubiKey;
